import axios, { API_BASE, handler } from './http-service';

const baseURL = `${API_BASE}/storage`;

export const fetchConfigs = () => {
  const url = `${baseURL}/options`;
  return handler(() => axios.get(url));
}

export const getExportStatus = (id: string) => {
  const url = `${baseURL}/exports/${id}`;
  return handler(() => axios.get(url));
}

export const getExportsList = () => {
  const url = `${baseURL}/exports`;
  return handler(() => axios.get(url));
}

export const requestForExport = (data: any) => {
  const url = `${baseURL}/exports`;
  return handler(() => axios.post(url, data));
}

export const removeExport = (id: string) => {
  const url = `${baseURL}/exports/${id}`;
  return handler(() => axios.delete(url));
}

const storageService = {
  fetchConfigs,
  getExportStatus,
  getExportsList,
  requestForExport,
  removeExport
}

export default storageService;
